module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"latest invoices":"Latest invoices"},"de":{"latest invoices":"Letzte Rechnungen"}}')
  delete Component.options._Ctor
}
